import CONQUER from "../../CONQUER";
import { STATUS, ACTIONS } from "../../../Models/ENUM";
import Entries from "./Entries";
import LOG, { log } from "../../../UTIL/LOG";
import ARRAY from "../../../UTIL/ARRAY";
import DATE from "../../../UTIL/DATE";
 
import RoomPlayerInstance from "./RoomPlayer/RoomPlayerInstance";

export const ROOM_CALL_STATE = {
    'IDLE': 0,
    'CALLING': 1,
    'RECEIVED': 2,
    'IN_PROGRESS': 3,
    'WAITING_PERMISSIONS': 4,
    'NO_PERMISSIONS': 5
};

class RoomInstance
{
    public conquer     : CONQUER;
    public graphID       : any;
    public name         : any;
    public avatarIDs    : any;
    public onMessage    : Function = function(e:any){};
    public onCallState : Function = function(e:number){};
    public data         : any = {};
    public key          : any;

    public Entries      : any;
    public gameKey      : any;
    public players      : any = {};

    private isConnected : boolean = false;

    public ME           : any;
    public RIVAL        : any;

    public onJoin       : any;
    public peer         : any;
    public eventsKey    :any;
    public callState    : number = ROOM_CALL_STATE.IDLE;
 
    constructor( conquer:CONQUER, vars?:any )
    {
        this.conquer    = conquer;
        this.doConstruct( vars );
    }

    private doConstruct( vars?:any )
    {
        if( !vars ) return;

        if( vars.gameKey ) this.gameKey = vars.gameKey;

        if( !vars._id ) return;

        this.graphID     = vars._id;
        this.name       = vars.name;
        this.avatarIDs  = vars.avatarIDs;
        this.key        = vars.key;
        this.gameKey    = vars.gameKey;
        this.Entries    = new Entries( this.conquer, this );
        this.eventsKey = 'ROOM_' + this.graphID;

        this.conquer.Rooms.pool[ this.graphID ] = this;
    }

    public async connect( onMessage?:Function, onJoin?:Function ) : Promise<any>
    {
        let value   = await this.conquer.do( ACTIONS.ROOM_GETONE, { gameKey:this.gameKey } ); // ADD AVATAR IDS FOR PROD

        this.doConstruct( value );

        if( onMessage ) this.onMessage = onMessage;

        this.isConnected = true;

        await this.join( onJoin );

        return Promise.resolve();
    };

    public async join( onJoin?:Function ) : Promise<any>
    {
        this.onJoin = onJoin;

        let avatar  = this.conquer.Avatars.ME;
        let snappy  = await avatar.Snappy.get();

        this.doSend( ACTIONS.PLAYERJOIN, { snappy:snappy, fullName:avatar.fullName, userPhoto:avatar.userPhoto } );
        this.isConnected = true;

        return Promise.resolve();
    };

    public leave()
    {
        this.isConnected = false;
        this.doSend( ACTIONS.PLAYERLEFT );
        this.conquer.Rooms.leave( this );
    };

    public chat( text:any )
    {
       // this.doSend( ACTIONS.CHAT, text );
    }

    public entry( text:any, metadata?: any )
    {
        this.doSend( ACTIONS.ENTRY, {text, metadata} );
    }
 
    public doSend( action:any, data?:any )
    {
        this.conquer.send( action, this.graphID, data || {} );
    }

    public _onServerMessage( message:any )
    {
        let action      = message.action;
        let avatarID    = message.avatarID;

        if( action == ACTIONS.GAMEDATA ) 
        {
            this.data = message.data;
            this.updatePlayers();
        }
 
        if( action == ACTIONS.PLAYERJOIN )
        {
            this.players[ message.data.avatarID ] = message.playerInstance = new RoomPlayerInstance( this, message.data );

            if( this.conquer.User.avatarID === message.data.avatarID ) 
            {
                this.ME = this.players[ message.data.avatarID ];

                if ( this.onJoin ) this.onJoin( this.ME );
                this.onJoin = null;
                return;

            }else if( !this.RIVAL ){
                this.RIVAL = this.players[ message.data.avatarID ];
            }
        }

        if( action == ACTIONS.TIME )
        {
            this.data.remaining = message.data.remaining; 
        }

        if( action == ACTIONS.PLAYERVARS || action == ACTIONS.PLAYERSTATE || action == ACTIONS.PLAYERSTATUS )
        {
            let player = this.players[ avatarID ];
            if( player ) player.update( message.data );
        }

        if( action == ACTIONS.ROOMSTATUS )
        {
            ARRAY.extract( message.data, this.data );
 
            this.updatePlayers();

            let status = this.data.status;

            if( status == STATUS.PLAYERSREADY ) 
            {
                if ( this.ME.data.status == STATUS.READY ) this.ME.Status.playing();
            }
        }

        if( action == ACTIONS.INSYNC ) return this.ME.onServerSynced();
 
        if( message.avatarID == this.conquer.User!.avatarID ) return;

        if( !this.isConnected ) return;

        this.onMessage( message );
        this.conquer.Signal.set(  this.eventsKey + ':onMessage', message );
    }

    private updatePlayers()
    {
        for( let avatarID in this.data.playerVars )
        {
            if( this.players[ avatarID ] ) 
            {
                this.players[ avatarID ].update( this.data.playerVars[ avatarID ] );
                continue;
            }

            this.players[ avatarID ] = new RoomPlayerInstance( this, this.data.playerVars[ avatarID ] );
        }
    }

    public setCallState( newState: number ){

        this.callState = newState;
        this.onCallState?.( newState );

    }
}

export default RoomInstance;